import { render, staticRenderFns } from "./addMasterCategory.vue?vue&type=template&id=4b01a5b2&"
import script from "./addMasterCategory.vue?vue&type=script&lang=js&"
export * from "./addMasterCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports